var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUpRightFromSquareRegular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0156 11.6221C12.5757 11.6221 12.2188 11.979 12.2188 12.4189V16.1377C12.2188 16.284 12.0994 16.4033 11.9531 16.4033H1.85938C1.71308 16.4033 1.59375 16.284 1.59375 16.1377V6.04395C1.59375 5.89765 1.71308 5.77832 1.85938 5.77832H5.57812C6.01973 5.77832 6.375 5.42305 6.375 4.98145C6.375 4.53984 6.01973 4.18457 5.57812 4.18457H1.85938C0.834395 4.18457 0 5.01797 0 6.04395V16.1377C0 17.1637 0.834395 17.9971 1.85938 17.9971H11.9531C12.9784 17.9971 13.8125 17.163 13.8125 16.1377V12.4189C13.8125 11.9807 13.4572 11.6221 13.0156 11.6221ZM16.2031 0.99707H10.625C10.1851 0.99707 9.82812 1.354 9.82812 1.79395C9.82812 2.23389 10.1867 2.59082 10.625 2.59082H14.2807L6.07617 10.792C5.76489 11.1033 5.76489 11.6075 6.07617 11.9189C6.23223 12.077 6.43477 12.1533 6.64062 12.1533C6.84648 12.1533 7.04836 12.0755 7.20408 11.9199L15.4062 3.71773V7.37207C15.4062 7.81201 15.7632 8.16895 16.2031 8.16895C16.6431 8.16895 17 7.81367 17 7.37207V1.79395C17 1.354 16.6447 0.99707 16.2031 0.99707Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpRightFromSquareRegular);
export default __webpack_public_path__ + "static/media/arrow-up-right-from-square-regular.8828ab9c694238bd083722ef14f328a6.svg";
export { ForwardRef as ReactComponent };